export default{
    foreignTrade:{
        Description:{
            title:'外贸服务',
            module1:{
                title:'专业外贸服务资源',
                btn:'查看详情',
                box1:{
                    title:'贸易政策与资源服务',
                    text:'提供全球贸易政策解读、市场准入指南及资源对接服务，助力企业合规经营，拓展国际市场。/反垄断）、知识产权保护、贸易争端化解全链路服务，赋能企业防控风险、稳健出海。',
                },
                box2:{
                    title:'物流与仓储服务',
                    text:'提供全球运输、仓储管理及报关服务，助力企业高效完成国际物流与仓储需求。',
                },
                box3:{
                    title:'翻译与本地化服务',
                    text:'提供多语言翻译、文档本地化及文化适配服务，助力企业精准传递信息，融入全球市场。',
                },
                box4:{
                    title:'风险管理服务',
                    text:'提供汇率、信用、物流等风险评估与提示，帮助企业降低国际贸易风险，保障交易安全。',
                },
            },
            module2:{
                title:'聚链全球通商，智汇外贸新章',
                text:'以一站式服务平台聚合全球优质外贸服务商，帮助企业实现高效通关、优化供应链、规避贸易风险，助力中国品牌与全球伙伴精准对接。',
                box1:{
                    title:'外汇风险管理',
                    text:'外汇分析与策略定制，运用金融工具对冲汇率风险，稳控利润波动，保障企业财务安全。',
                },
                box2:{
                    title:'退税优化咨询',
                    text:'精准解读各国退税政策，优化申报流程，助企业高效完成退税，加速资金回笼。',
                },
                box3:{
                    title:'国际市场信息服务',
                    text:'实时解析行业趋势与竞对动态，数据驱动精准决策，助力企业抢占市场先机。',
                },
                box4:{
                    title:'供应链管理咨询',
                    text:'深度优化供应链效率与成本结构，打造敏捷协作体系，降本提效强化竞争力。',
                },
                box5:{
                    title:'跨境电商解决方案',
                    text:'一站式全链路支持：覆盖建站、支付、仓储及营销，快速开拓全球电商市场。',
                },
                box6:{
                    title:'品牌国际化战略咨询',
                    text:'定制海外品牌定位与推广策略，塑造全球知名度，打开国际市场影响力。',
                },
            },
        }
    }
}